import { render } from "./CreatePurchasePage.vue?vue&type=template&id=18ff0513&scoped=true&ts=true"
import script from "./CreatePurchasePage.vue?vue&type=script&lang=ts"
export * from "./CreatePurchasePage.vue?vue&type=script&lang=ts"

import "./CreatePurchasePage.vue?vue&type=style&index=0&id=18ff0513&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ff0513"]])

export default __exports__